<template>
  <div>
    <v-alert  :value="true"  v-if="errorMessage != null" type="error" >{{ errorMessage }}</v-alert>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  export default {
    components: {
      
    },
    data () {
      return {
        errorMessage: null
      }
    },
    mounted () {
      console.log('Hit AUTH script')
      
      var cognitoCode = this.getQueryVariable('code')
      var redirectURI = process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI

      if (window.location.href.includes("referrer=store")) {
        redirectURI += '?referrer=store'
      }else if (window.location.href.includes("referrer=web")) {
         redirectURI += '?referrer=web'
      }

      var bodyParams = {
        grant_type: 'authorization_code',
        client_id : process.env.VUE_APP_AWS_CLIENT_ID,
        redirect_uri : redirectURI,
        code : cognitoCode
      }

      var vm = this

      axios({
        method: 'post',
        url: 'https://'+ process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER +'/oauth2/token',
        data: qs.stringify(bodyParams),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      }).then(function (response) {
        console.log('response', response)


        var accessToken = response.data.access_token
        var idToken = response.data.id_token
        var refreshToken = response.data.refresh_token
        var userSub = vm.$getUserSubFromIdToken(idToken)
        var userPrivacyAccepted = vm.$getUserFieldFromIdToken('custom:privacy_accepted', idToken)
        var secureString = ''
        var expDate = new Date();
        var time = expDate.getTime();
        var expireTime = time + 3600 * 1000 * 24 * 365 //1 year
        expDate.setTime(expireTime)
        

        if(process.env.VUE_APP_COOKIE_SECURE === 'true'){
          secureString = '; secure'
        }


        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.refreshToken=`+ refreshToken+ `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.accessToken=`+ accessToken+ `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.idToken=`+ idToken+ `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser=`+ userSub + `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.clockDrift=0; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        

        //Set Cognito Cookies
        /*vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.refreshToken`, refreshToken, {expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.accessToken`, accessToken, {expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.idToken`, idToken, {expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`, userSub,{expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.clockDrift`, 0 ,{expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        */
        
        console.log('cookies set, now redirecting user')
           
        var tokens = {
          'idToken' : idToken,
          'refreshToken' : refreshToken,
          'accessToken' : accessToken
        }

        // mobile app event trigger
        if (typeof window.android !== 'undefined') { 
          window.android.onSignInSuccess(idToken) 
          window.android.passTokens(JSON.stringify(tokens))
        }
        
        if (typeof window.webkit !== 'undefined') { 
          window.webkit.messageHandlers.iOS.postMessage(idToken)
          window.webkit.messageHandlers.iOSTokens.postMessage(JSON.stringify(tokens))
        }

        //Handle Website and Store redirects
        if (window.location.href.includes("referrer=store")) {
          if (userPrivacyAccepted==='true') {
            window.location = process.env.VUE_APP_CLUB_STORE_URL
          } else {
            localStorage.completeRegistrationRedirect = process.env.VUE_APP_CLUB_STORE_URL
            vm.$router.push("/complete-registration/")
          }
        } else if (window.location.href.includes("referrer=web")){
          if (userPrivacyAccepted==='true') {
            window.location = process.env.VUE_APP_CLUB_WEBSITE_URL
          } else {
            localStorage.completeRegistrationRedirect = process.env.VUE_APP_CLUB_WEBSITE_URL
            vm.$router.push("/complete-registration/")
          }
        }else if(localStorage.referrer){ // if they were a referral sign in then clear this and redirect them.
          var redirect = localStorage.referrer
          console.log('redirecting to ' + redirect)
          localStorage.removeItem('referrer')
          window.location = redirect
        }else{
          vm.$router.push("/profile")
        }
      }).catch(function (error) {
        console.log('error',error)
        vm.errorMessage = "Unable to complete social sign in at this time, please try again."
      })
    },
    methods: {
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      }
    }
  }
</script>